var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-page"},[_c('FilterForm',{attrs:{"module":_vm.$route.params.title,"submitted":_vm.submitted,"code":_vm.code},on:{"filterform":function($event){_vm.filterform($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }